<template>
  <div class="file-select">
    <div class="title-bar nav-bar-bgcolor" @click="toggleNav">{{ $t('file.selectDestination') }}</div>
    <file-header
      :headerName="headerItem.name"
      scenario="fileSelect"
      @item-change="onHeaderItemChange"
      @close-select="onCloseSelect"
    />
      <file-nav
        :show="showSelectNav"
        scenario="fileSelect"
      />
    <file-list
      scenario="fileSelect"
      @list-info-change="onListInfoChange"
    />
    <!-- create folder -->
    <van-popup
      class="create-rename-page"
      v-model="showCreateFolder"
      position="right"
      :lazy-render="false"
      :overlay="false"
    >
      <create-rename
        actionName="create"
        v-if="showCreateFolder"
        :headerItem="headerItem"
        @close-create-rename="toggleCreateFolder"
      />
    </van-popup>
    <div class="action-bar has-border-top">
      <div :class="{'disable': disableCreate}" @click="toggleCreateFolder">{{ $t('file.action.createFolder') }}</div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import config from '@/config'
import FileNav from './FileNav'
import FileHeader from './FileHeader'
import FileList from './FileList'
import CreateRename from './CreateRename'

export default {
  name: 'FileSelect',
  components: {
    FileNav,
    FileHeader,
    FileList,
    CreateRename
  },
  i18n,
  props: {
    initDest: Object
  },
  data () {
    return {
      is_personal_space_closed: config.enterprise_info.is_personal_space_closed,
      headerItem: {},
      listInfo: {},
      showSelectNav: false,
      showCreateFolder: false
    }
  },
  computed: {
    disableCreate () {
      const permissions = this.headerItem.permissions || []
      return !permissions.includes('create_folder') && !permissions.includes('item_upload')
    }
  },
  watch: {
    $route (to, from) {
      this.showCreateFolder = !!to.query.createfolder
      this.showSelectNav = !!to.query.selectnav
    },
    'store.newFolder' (item) {
      // 新建文件夹并进入
      if (item.createOnFileSelect) {
        this.selectListStack.push({space: 'folder', id: item.id})
      }
    }
  },
  created () {
    let space, id
    if (this.initDest) {
      ({space, id} = this.initDest)
    } else {
      if (this.is_personal_space_closed) {
      } else {
        space = 'own'
        id = null
      }
    }

    this.selectListStack.push({space, id})
  },
  methods: {
    onListInfoChange (info) {
      if (info.error) {
        if (this.selectListStack.length === 1) {
          this.$emit('close-select')
        } else {
          this.selectListStack.pop()
        }
        return
      }
      this.listInfo = info
      if (['own', 'collab', 'external'].includes(info.space)) {
        this.headerItem = {...this.headerItem, permissions: info.permissions}
        this.$emit('dest-change', this.headerItem)
      }
      if (info.space === 'external') {
        this.headerItem.name = info.current_path[0].name
      }
    },
    toggleNav () {
      this.toggleQuery('selectnav')
    },
    onHeaderItemChange (item) {
      this.headerItem = item
      this.$emit('dest-change', item)
    },
    toggleCreateFolder () {
      if (!this.disableCreate) {
        this.toggleQuery('createfolder')
      }
    },
    onCloseSelect () {
      this.$emit('close-select')
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.file-select {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  & .title-bar {
    flex: 0 0 auto;
    height: 30px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    z-index: 2;
  }

  & .action-bar {
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    background-color: #fff;

    & .disable {
      color: #dadada
    }

    & .btn {
      min-width: 66px;
      color: #fff;
    }

  }

  & .file-list {
    flex: 1 1 auto;
    background-color: #eeeff5;
  }
}
</style>
